define('plugin/facebook/view/FacebookView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Facebook login view
     *
     * @class FacebookView
     */
    return LayoutView.extend({

        template: '#facebook_view',
        ui: {
            loginBtn: '#sb_facebook_login_btn',
            logoutBtn: '#sb_facebook_logout_btn'
        },
        triggers: {
            'click @ui.loginBtn': 'login',
            'click @ui.logoutBtn': 'logout'
        }

    });

});
